import React, { useState } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { claimStackingAction } from "../../Action/user.action";
import toast from 'react-hot-toast';

const StakeHistory = ({ stakingHistory, loadMoreHistory, paginationStatus }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [isClaimLoading, setIsClaimLoading] = useState(false);

    const handleLoadMore = () => {
        setCurrentPage(prevPage => prevPage + 1);
        loadMoreHistory(currentPage + 1);
    };

    const claimStakingAmount = async (rowId) => {
        try {
            setIsClaimLoading(true);
            const data =
            {
                stak_id: rowId
            };
            console.log(data);
            const res = await claimStackingAction(data);
            setIsClaimLoading(false);
            if (res.success) {
                toast.success(res.msg);
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            } else {
                toast.error(res.msg || "Claim failed");
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong!");
        }
    };

    return (
        <div>
            <h3 className='sofia-sans'>Staking History</h3>
            <br />
            {stakingHistory?.length > 0 ? (
                stakingHistory.map((history, index) => (
                    <Row key={index} className='sofia-sans'>
                        <Col xl={12}>
                            <div
                                style={{
                                    background: "rgba(221, 63, 255, 0.1)",
                                    borderRadius: 10,
                                    textTransform: "capitalize",
                                    marginBottom: "10px",
                                }}
                            >

                                <Row className="gy-2 px-3 pt-3 mt-2 justify-content-between sofia-sans">
                                    <Col className="text-center">
                                        <p className="text-secondary wcard-title mb-2 ">Date</p>
                                        <p className="wcard-data">{history.date || "N/A"}</p>
                                    </Col>

                                    <Col className="text-center">
                                        <p className="text-secondary wcard-title mb-2">Stake Amount</p>
                                        <p className="">{history.stake_amount || "0"} ANANT</p>
                                    </Col>

                                    <Col className="text-center">
                                        <p className="text-secondary wcard-title mb-2">Stake Plan</p>
                                        <p className="wcard-data">
                                            {history.duration_month ? `${history.duration_month} Months (${history.apy}% APR)` : "N/A"}
                                        </p>
                                    </Col>

                                    <Col className="text-center">
                                        <p className="text-secondary wcard-title mb-2">Release Date</p>
                                        <p className="wcard-data">{history.release_date || "N/A"}</p>
                                    </Col>

                                    <Col className="text-center">
                                        <p className="text-secondary wcard-title mb-2">Release Amount</p>
                                        <p className="wcard-data">{history.release_amount || "0"} ANANT</p>
                                    </Col>

                                    <Col className="text-center d-flex align-items-baseline justify-content-center">
                                        <Button
                                            variant="main2"
                                            className="w-100 mb-3"
                                            disabled={!history.is_enable || history.claim == 1 || isClaimLoading}
                                            onClick={() => claimStakingAmount(history.id)}
                                        >
                                            {history.claim == 0 ? 'Claim' : 'Claimed'}
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                ))
            ) : (
                <div
                    className="text-center d-flex justify-content-center align-items-center flex-column"
                    style={{
                        padding: "20px",
                        color: "#d3d3d3",
                        borderRadius: "8px",
                        height: "80vh",
                    }}
                >
                    <img
                        style={{ width: "auto", height: "auto" }}
                        src="assets\images\newdesign\nodata-new.png"
                        alt="No Data"
                    />
                    <h4>No data found</h4>
                </div>
            )}
            {!paginationStatus && (<>
                {stakingHistory.length >= 10 && (
                    <div className="text-center mt-3">
                        <Button variant="main2" onClick={handleLoadMore}>
                            Load More
                        </Button>
                    </div>
                )}
            </>)}
        </div>
    );
};

export default StakeHistory;